/* eslint no-mixed-operators: 0 */

// Turbolinks handles non 200 responses differently, this patch causes Turbolinks to behave normally.
// Ticket: https://eezyinc.atlassian.net/browse/ES-1309
// See https://github.com/turbolinks/turbolinks/issues/179#issuecomment-289287888

const applyTurbolinksErrorsPatch = () => {
  window.Turbolinks.HttpRequest.prototype.requestLoaded = function () {
    return this.endRequest(() => {
      const code = this.xhr.status;
      if (code >= 200 && code < 300
          || code === 403 || code === 404 || code === 500) {
        this.delegate.requestCompletedWithResponse(
          this.xhr.responseText,
          this.xhr.getResponseHeader('Turbolinks-Location'),
        );
      } else {
        this.failed = true;
        this.delegate.requestFailedWithStatusCode(code, this.xhr.responseText);
      }
    });
  };
};

export default applyTurbolinksErrorsPatch;
